import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-gold text-wine text-xs font-bold py-2 px-4 text-center shadow-md flex justify-center items-center gap-2" data-id="element-248">
      <span data-id="element-249">⏰ Precio de lanzamiento — cierra en:</span>
      <span className="tabular-nums tracking-wider" data-id="element-250">
        {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
        {formatTime(timeLeft.seconds)}
      </span>
    </div>;
}